// Angular
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
// Service
import { ViewsService } from '../../../../../../../../services/views.service';
import { CVfUtilsService } from '../../../../../../../services/cvf-utils.service';
// Model
import { FormControl, FormGroup } from '@angular/forms';
import { SCHEMA_TYPE } from '../../../../../../../../models/enums.model';
import { SmartTagModel } from '../../../model/smartTag.model';
import { SmartTagTemplateForm } from '../../../model/smart-tag-template-form.model';

@Component({
	selector: 'cv-schema-render-smart-tag-default-template',
	templateUrl: './smart-tag-default-template.component.html',
})
export class SmartTagDefaultTemplateComponent extends SmartTagTemplateForm implements OnInit {

	@Input() smartTagModel: SmartTagModel = null;
	@Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

	public schemaType: any = SCHEMA_TYPE; // not needed
	public orderSchema = '';

	constructor(
		private viewsService: ViewsService,
		protected cvfUtils: CVfUtilsService
	) {
		super(cvfUtils);
	}

	ngOnInit() {

		this.orderSchema = this.viewsService.order.schema;
		// Basic Form
		this.innerForm = new FormGroup({
			description: new FormControl(this.smartTagModel.description)
		});

		// Everytime the Form Change
		this.innerForm.valueChanges.subscribe(() => this.onValuesChange());
	}

	/**
	 * Emit values and status of this Form, for inner components and library too
	 * @private
	 */
	public onValuesChange(): void {
		const formValue = this.processOutputObject(this.smartTagModel);
		this.valueChange.next({ valid: this.innerForm.valid, value: formValue });
	}

}
